var _jsxFileName = "/repo/packages/webassets/src/theme/index.tsx",
  _this = this;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React, { createContext } from 'react';
import { createTheming, ThemeProvider } from 'react-jss';
import { WrenchTheme as WebAssetsTheme } from '@wds/styles';
var ThemeContext = /*#__PURE__*/createContext({});
var theming = createTheming(ThemeContext);
var WebAssetsThemeProvider = theming.ThemeProvider,
  useWebAssetsTheme = theming.useTheme;
var WebAssetsThemeWrapper = function WebAssetsThemeWrapper(_ref) {
  var children = _ref.children;
  var theme = useWebAssetsTheme();
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: _objectSpread(_objectSpread({}, WebAssetsTheme), theme),
    __self: _this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 17,
      columnNumber: 5
    }
  }, children);
};
var withWebAssetsTheme = function withWebAssetsTheme(Component) {
  return function (props) {
    return /*#__PURE__*/React.createElement(WebAssetsThemeWrapper, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 27,
        columnNumber: 5
      }
    }, /*#__PURE__*/React.createElement(Component, Object.assign({}, props, {
      __self: _this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 28,
        columnNumber: 7
      }
    })));
  };
};
export { WebAssetsThemeProvider, useWebAssetsTheme, WebAssetsTheme, WebAssetsThemeWrapper, withWebAssetsTheme };
//# sourceMappingURL=index.js.map